"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailBeforeFreebie = exports.emailBeforeFreebieUrlInclusion = void 0;
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
/** We have a convention of triggering this test on the inclusion of "em=1" in the URL */
exports.emailBeforeFreebieUrlInclusion = 'em=1';
var EmailBeforeFreebie = function (_a) {
    var setCollectedEmail = _a.setCollectedEmail, onSubmitGaEventName = _a.onSubmitGaEventName, bundleProperties = _a.bundleProperties;
    // this will go to the CMS is the test succeeds...
    var topline = 'Your baby deserves the best!';
    var headline = 'Claim Your Freebie!';
    var subline = 'Join our email list and claim a Freebie with your first Bundle!';
    var bgImageUrl = 'https://d25mydkrxair63.cloudfront.net/email-b4-freebie-bg.jpg';
    var _b = (0, react_hook_form_1.useForm)(), register = _b.register, handleSubmit = _b.handleSubmit;
    var onSubmit = function (_a) {
        var _b, _c;
        var email = _a.email;
        // Identify the email for klaviyo and send an event. We have to request the track in a callback function
        // because the track event will fail to be recorded if the track code runs before the user is identified.
        // https://community.klaviyo.com/analytics-and-deliverability-72/send-track-and-identify-in-the-same-call-using-javascript-api-5512?postid=19888#post19888
        var onIdentify = function () {
            var _a;
            (_a = window._learnq) === null || _a === void 0 ? void 0 : _a.track('Submitted email before bundler freebie', bundleProperties ? __assign({}, bundleProperties) : {});
        };
        (_b = window._learnq) === null || _b === void 0 ? void 0 : _b.identify({ $email: email }, undefined, undefined, onIdentify);
        // emit a ga event
        if (onSubmitGaEventName)
            (_c = window.dataLayer) === null || _c === void 0 ? void 0 : _c.push({ event: onSubmitGaEventName });
        setCollectedEmail(email); // once we set collectedEmail, this component will dismiss
    };
    return (react_1.default.createElement("div", { className: 'position-absolute top-0 bottom-0 right-0 left-0 flex-container align-middle align-center', style: { zIndex: 3, backgroundColor: '#E5E6E5', backgroundImage: "url(".concat(bgImageUrl, ")"), backgroundSize: 'cover' } },
        react_1.default.createElement("div", { className: 'text-center width-100 padding-12' },
            react_1.default.createElement("div", { className: 'font-bold margin-bottom-2' }, topline),
            react_1.default.createElement("h2", { className: 'h1 margin-bottom-3' }, headline),
            react_1.default.createElement("div", { className: 'h6 margin-bottom-10 font-bold' }, subline),
            react_1.default.createElement("div", { className: 'margin-horizontal-auto', style: { maxWidth: 400 } },
                react_1.default.createElement("form", { onSubmit: handleSubmit(onSubmit) },
                    react_1.default.createElement("input", { type: 'email', name: 'email', className: 'bordered border-black', placeholder: 'Email Address', required: true, ref: register() }),
                    react_1.default.createElement("button", { type: 'submit', className: 'button btn-form btn-outline' }, "Continue"),
                    react_1.default.createElement("div", { className: 'h-2' }),
                    react_1.default.createElement("div", { className: 'text-sm' }, "By completing this form you are signing up to receive Hello Bello emails and can unsubscribe at any time."))))));
};
exports.EmailBeforeFreebie = EmailBeforeFreebie;
